import { Typography } from '@mui/material';
import { neobetRaisedActionButtonStyles as styles } from '../../../../styles/components/neobetRaisedActionButton';
import { mergeSx } from '../../../../utils/styles';

type NeobetRaisedActionButtonLabelProps = {
  children: React.ReactNode;
  inactive?: boolean;
};

const NeobetRaisedActionButtonLabel = ({ children, inactive }: NeobetRaisedActionButtonLabelProps) => {
  const inactiveText = {
    ...styles.text,
    color: 'neutral.400',
  };

  if (inactive) {
    return (
      <Typography sx={styles.label}>
        <Typography component='span' sx={inactiveText}>
          {children}
        </Typography>
      </Typography>
    );
  }

  return (
    <Typography sx={styles.label}>
      <Typography component='span' aria-hidden sx={styles.stroke}>
        {children}
      </Typography>
      <Typography component='span' aria-hidden sx={mergeSx(styles.stroke, styles.lowerStroke)}>
        {children}
      </Typography>
      <Typography component='span' sx={styles.text}>
        {children}
      </Typography>
    </Typography>
  );
};

export default NeobetRaisedActionButtonLabel;
